import { BalanceDetailsType } from 'b2b-common/core/account/api/BalanceDetails.types';
import {
  CLEAR_ACCOUNT_BALANCE_DETAILS,
  FETCH_BALANCE_DETAILS,
  FETCH_BALANCE_DETAILS_FULFILLED,
  FETCH_BALANCE_DETAILS_REJECTED,
} from './actionTypes';
import {
  ClearAccountBalanceDetails,
  FetchBalanceDetailsAction,
  FetchBalanceDetailsFulfilledAction,
  FetchBalanceDetailsRejectedAction,
} from './types';

const fetchBalanceDetails = (): FetchBalanceDetailsAction => ({
  type: FETCH_BALANCE_DETAILS,
});

const fetchBalanceDetailsFulfilled = (response: BalanceDetailsType): FetchBalanceDetailsFulfilledAction => ({
  type: FETCH_BALANCE_DETAILS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchBalanceDetailsRejected = (error: ErrorType): FetchBalanceDetailsRejectedAction => ({
  type: FETCH_BALANCE_DETAILS_REJECTED,
  payload: {
    error,
  },
});

const clearAccountBalanceDetails = (): ClearAccountBalanceDetails => ({
  type: CLEAR_ACCOUNT_BALANCE_DETAILS,
});

export {
  clearAccountBalanceDetails,
  fetchBalanceDetails,
  fetchBalanceDetailsFulfilled,
  fetchBalanceDetailsRejected,
};
